import { RangeModifier } from 'react-day-picker/types/Modifiers';
import { ObjectsParams } from '../../types/ParamsTypes';

export const getUpdatedObjectFilterDateRangeParams = (
  objects: ObjectsParams,
  range: RangeModifier,
): ObjectsParams => {
  const updatedObjectFilterParams = { ...objects };
  if (range.from) {
    const fromDateArray = range.from
      .toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      })
      .split('/');

    updatedObjectFilterParams.fromDate =
      fromDateArray[2] + '-' + fromDateArray[0] + '-' + fromDateArray[1];
  }

  if (range.to) {
    const toDateArray = range.to
      .toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      })
      .split('/');

    updatedObjectFilterParams.toDate = toDateArray[2] + '-' + toDateArray[0] + '-' + toDateArray[1];
  }

  return updatedObjectFilterParams;
};
